import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=0412071e&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"
import style0 from "./Login.vue?vue&type=style&index=0&id=0412071e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0412071e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SocialLogin: require('/home/bitrix/frontend/components/forms/SocialLogin.vue').default,MtInput: require('/home/bitrix/frontend/components/form/MtInput.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default,FormWrap: require('/home/bitrix/frontend/components/sidebars/FormAside/FormWrap.vue').default,MtModal: require('/home/bitrix/frontend/components/Modal/MtModal.vue').default})
